/**
 * @file shared.module.ts
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { PrescriptionDetailComponent } from './prescription-detail/prescription-detail.component';
import { MaterialModule } from '../core/modules/material.module';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { ClaimDetailComponent } from './claim-detail/claim-detail.component';
import { RecentOrderComponent } from './recent-order/recent-order.component';
import { NewAddressComponent } from './new-address/new-address.component';
import { NgxMaskModule } from 'ngx-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NewCreditCardComponent } from './new-credit-card/new-credit-card.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ConfirmationAlertPopupComponent } from './confirmation-alert-popup/confirmation-alert-popup.component';
import { DowntimeDialogComponent } from './downtime-dialog/downtime-dialog.component';
import { PmartPatientEnrollmentFormComponent as MailOrderPatientEnrollmentFormComponent } from './mail-order-patient-enrollment-form/mail-order-patient-enrollment-form.component';
import { UpdateMailOrderProfileDialogComponent } from './update-mail-order-profile-dialog/update-mail-order-profile-dialog.component';
import { PipesModule } from '../pipes/pipes.module';
import { DirectivesModule } from '../directives/directives.module';
import { RequestHistoricalDataPopupComponent } from './request-historical-data-popup/request-historical-data-popup.component';
import { CommonConfirmationPopupComponent } from './common-confirmation-popup/common-confirmation-popup.component';
import { MailOrderProfilePendingComponent } from './mail-order-profile-pending/mail-order-profile-pending.component';


@NgModule({
  declarations: [
    PrescriptionDetailComponent,
    OrderDetailsComponent,
    ClaimDetailComponent,
    RecentOrderComponent,
    NewAddressComponent,
    NewCreditCardComponent,
    ConfirmationDialogComponent,
    ConfirmationAlertPopupComponent,
    DowntimeDialogComponent,
    MailOrderPatientEnrollmentFormComponent,
    UpdateMailOrderProfileDialogComponent,
    RequestHistoricalDataPopupComponent,
    CommonConfirmationPopupComponent,
    MailOrderProfilePendingComponent
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    FormsModule,
    MaterialModule,
    NgxMaskModule,
    ReactiveFormsModule,
    PipesModule,
    DirectivesModule
  ],
  exports: [RecentOrderComponent, MailOrderProfilePendingComponent, DirectivesModule, PipesModule]
})
export class SharedModule { }
